import { render, staticRenderFns } from "./personDetail.vue?vue&type=template&id=66e477fb&scoped=true"
import script from "./personDetail.vue?vue&type=script&lang=js"
export * from "./personDetail.vue?vue&type=script&lang=js"
import style0 from "./personDetail.vue?vue&type=style&index=0&id=66e477fb&prod&lang=scss&scoped=true"
import style1 from "./personDetail.vue?vue&type=style&index=1&id=66e477fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e477fb",
  null
  
)

export default component.exports